import { BaseMyBetsFilterStore } from "./BaseMyBetsFilterStore";

export class MyBetsFilterStore extends BaseMyBetsFilterStore {}
